var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var FolderIcon = function (_a) {
    var width = _a.width, height = _a.height;
    return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48", width: width, height: height }, { children: [_jsx("path", { fill: "#FFA726", d: "M40,12H22l-4-4H8c-2.2,0-4,1.8-4,4v24c0,2.2,1.8,4,4,4h32c2.2,0,4-1.8,4-4V16C44,13.8,42.2,12,40,12z" }), _jsx("path", { fill: "#FB8C00", d: "M40,12H22l-4-4H8c-2.2,0-4,1.8-4,4v4h40v-4C44,13.8,42.2,12,40,12z" })] })));
};
export default FolderIcon;
